var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "out", attrs: { id: "top" } }, [
    _c("div", { staticClass: "title clear" }, [
      _c("div", { staticClass: "apt" }, [
        _vm._v(
          "\n      " +
            _vm._s(
              _vm.propsProerty == _vm.landOnly ? "Lot Number" : "Residence"
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "status" }, [_vm._v("Stamp Duty")]),
      _vm._v(" "),
      _c("div", { staticClass: "pri" }, [_vm._v("Council Rates (qtr)")])
    ]),
    _vm._v(" "),
    !_vm.loading
      ? _c("div", { staticClass: "lst" }, [
          _vm.propsData && _vm.propsData[0]
            ? _c(
                "div",
                _vm._l(this.list, function(item, index) {
                  return _c(
                    "div",
                    { key: item.a, staticClass: "box", class: item.class },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "line",
                          class: {
                            border:
                              index == _vm.propsData.length - 1 || item.unfold
                          }
                        },
                        [
                          _c("div", { staticClass: "inn apt" }, [
                            _vm._v(_vm._s(item.apt))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "inn status" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  item.stampDuty
                                    ? "$" + _vm.numberWithCommas(item.stampDuty)
                                    : "TBA"
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "inn pri" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  item.councilRates
                                    ? "$" +
                                        _vm.numberWithCommas(item.councilRates)
                                    : "TBA"
                                ) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "inn arw",
                            class: { unfold: item.unfold },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.unfold(index)
                              }
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "more",
                          class: { hid: !item.unfold },
                          style: { marginBottom: item.unfold ? ".34rem" : "0" }
                        },
                        [
                          _c("div", { staticClass: "top" }, [
                            _c("div", { staticClass: "tit clear" }, [
                              _c("div", { staticClass: "bed" }, [
                                _vm._v("Transfer Fee")
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "bed" }, [
                                _vm._v("Property Title")
                              ]),
                              _vm._v(" "),
                              _vm.showFeesColumn
                                ? _c("div", { staticClass: "bat" }, [
                                    _vm._v(
                                      "\n                Estimated Fees (qtr)\n              "
                                    )
                                  ])
                                : _vm._e()
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "cons" }, [
                              _c("div", { staticClass: "bed" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.lodgement
                                        ? "$" +
                                            _vm.numberWithCommas(item.lodgement)
                                        : "TBA"
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "bed" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      item.titleType ? item.titleType : "TBA"
                                    ) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              _vm.showFeesColumn
                                ? _c("div", { staticClass: "bat" }, [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          item.strataFees
                                            ? "$" +
                                                _vm.numberWithCommas(
                                                  item.strataFees
                                                )
                                            : "TBA"
                                        ) +
                                        "\n              "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ])
                        ]
                      )
                    ]
                  )
                }),
                0
              )
            : _c(
                "div",
                {
                  staticStyle: {
                    "text-align": "center",
                    padding: "1rem 0",
                    "font-size": ".3rem",
                    color: "#3F3F46"
                  }
                },
                [_vm._v("\n      No data\n    ")]
              ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "text-align": "center",
                padding: "1rem 0",
                "font-size": ".25rem",
                color: "#3F3F46"
              }
            },
            [
              _vm._v(
                "\n      Please note the above information is subject to change at any time. At\n      the time of preparation every care was taken to ensure this information\n      was correct. This information should be used for informative purposes\n      only. Stamp duty and lodgement fee estimates were derived from\n      calculators and all other fees are based on estimates per quarter. All\n      figures are to be used as a guide only. All associated costs of buying a\n      property should be discussed with your conveyancer or solicitor.\n    "
              )
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-655b7652", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-655b7652","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/propertyDetails/associatedFeeSection.vue
// module id = null
// module chunks = 